import HistoryReportPage from './HistoryReportPage';
export default HistoryReportPage;